// src/strategy/CaptureFirstStrategy.ts
import { MoveStrategy } from './MoveStrategy';
import { Position, BoardState } from '../model/BoardState';
import logger from '../utils/Logger';

/**
 * A strategy that prioritizes capturing opponent pieces.
 * It will always select the highest-value capture available.
 */
export class CaptureFirstStrategy implements MoveStrategy {
  private readonly captureMoves: Position[];

  constructor(captureMoves: Position[]) {
    this.captureMoves = captureMoves;
  }

  getLegalMoves(_position: Position | null, _boardState: BoardState): Position[] {
    if (this.captureMoves.length === 0) {
      logger.debug("CaptureFirstStrategy: No capture moves available");
      return [];
    }
    
    const move = this.captureMoves[0];
    if (move.piece) {
      // Look for what piece is being captured for logging
      if (_boardState && _boardState.pieces && Array.isArray(_boardState.pieces)) {
        const capturedPiece = _boardState.pieces.find(p => 
          p.position.row === move.row && 
          p.position.col === move.col && 
          p.color !== 'white'
        );
        
        if (capturedPiece) {
          logger.debug(`CaptureFirstStrategy: Piece ${move.piece.type} will capture ${capturedPiece.type} at (${move.row}, ${move.col})`);
          logger.debug(`Computer choosing to capture ${capturedPiece.type} with ${move.piece.type} at position (${move.row}, ${move.col})`);
        } else {
          logger.debug(`CaptureFirstStrategy: Piece ${move.piece.type} will capture at (${move.row}, ${move.col})`);
          logger.debug(`Computer choosing to capture with ${move.piece.type} at position (${move.row}, ${move.col})`);
        }
      } else {
        logger.debug(`CaptureFirstStrategy: Piece ${move.piece.type} will capture at (${move.row}, ${move.col})`);
        logger.debug(`Computer choosing to capture with ${move.piece.type} at position (${move.row}, ${move.col})`);
      }
    }
    
    // Return only the best capture move
    return [move];
  }

  getStrategyName(): string {
    return "Capture First Strategy";
  }
}
